/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable no-else-return */
const themeCurrency = require('@shopify/theme-currency');

const Handlebars = require('handlebars/dist/handlebars.min.js').default;

const handlebarsHelpers = function handlebarsHelpers() {
  // Task: Compare two values and return true or false
  Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
    const operators = {
      '==': v1 == v2 ? true : false,
      '===': v1 === v2 ? true : false,
      '!=': v1 != v2 ? true : false,
      '!==': v1 !== v2 ? true : false,
      '>': v1 > v2 ? true : false,
      '>=': v1 >= v2 ? true : false,
      '<': v1 < v2 ? true : false,
      '<=': v1 <= v2 ? true : false,
      '||': v1 || v2 ? true : false,
      '&&': v1 && v2 ? true : false
    };

    if (operators.hasOwnProperty(operator)) {
      if (operators[operator]) {
        return options && options.fn(this);
      }
      return options && options.inverse(this);
    }

    return console.warn('Error: Compare operator "' + operator + '" not found');
  });

  // Task: If either value is true
  Handlebars.registerHelper('length', function (v1, operator, v2, options) {
    if (operator == '||') {
      if (v1.length > 0 || v2.length > 0) {
        return options.fn(this);
      }
      return options.inverse(this);
    } else if (operator == '&&') {
      if (v1.length > 0 && v2.length > 0) {
        return options.fn(this);
      }
      return options.inverse(this);
    }

    return console.warn('Error: Length operator "' + operator + '" not found');
  });

  // Task: If variables are not all empty
  Handlebars.registerHelper('hasAnyResults', function (v1, v2, v3, v4, options) {
    if (v1.length > 0 || v2.length > 0 || v3.length > 0 || v4.length > 0) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  // Task: Perform a math function and return the result
  Handlebars.registerHelper('math', function (v1, transformation, v2, options) {
    const operators = {
      '+': v1 + v2,
      '-': v1 - v2,
      '/': v1 / v2,
      '*': v1 * v2
    };

    if (typeof v1 !== 'number' || typeof v2 !== 'number') {
      return console.warn('Error: "' + v1 + '" or "' + v2 + '" not a number');
    }

    if (operators.hasOwnProperty(transformation)) {
      return operators[transformation];
    }

    return console.warn('Error: Transformation "' + transformation + '" not found');
  });

  // Task: Return specified param from inside keyed object
  Handlebars.registerHelper('lookupKey', function (object, key, param, options) {
    if (object.hasOwnProperty(key)) {
      return object[key][param];
    }

    return null;
  });

  // Task: Return specified param from inside keyed object
  Handlebars.registerHelper('containsKey', function (object, subObject, key, options) {
    if ((typeof object === 'undefined' ? 'undefined' : typeof object) == 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = object[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          var keys = Object.keys(item);
          if (keys.indexOf(subObject) > -1) {
            if (item[subObject] !== null) {
              var subKeys = Object.keys(item[subObject]);
              if (subKeys.indexOf(key) > -1) {
                return true;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }

    return console.warn('Error: Key "' + key + '" not found in subObject');
  });

  // Task: Return JSON object instead of [Object object]
  Handlebars.registerHelper('json', function (context, options) {
    return JSON.stringify(context);
  });

  // Task: Strip html tags from the passed content
  Handlebars.registerHelper('strip_html', function (content, options) {
    return content.toString().replace(/<[^>]*>/g, '');
  });

  // Task: Return a long dash if the passed content is null/undefined/blank
  Handlebars.registerHelper('blank', function (content, options) {
    if (content === undefined || content === null || content === '') {
      return '—';
    }
    return content;
  });

  // Task: Return the current timestamp
  Handlebars.registerHelper('timestamp', function (options) {
    return 't_' + new Date().getTime();
  });

  // Task: Return the size of an object
  Handlebars.registerHelper('size', function (object, options) {
    var size = Object.keys(object).length;

    return size;
  });

  // Task: Loop a certain amount of times
  Handlebars.registerHelper('loop', function (amount, block) {
    var loop = '';
    var iteration = Math.round(Number(amount));

    for (var i = 0; i < iteration; ++i) {
      loop += block.fn(i);
    }

    return loop;
  });

  // Task: Return the index with an index of 1 instead of zero
  Handlebars.registerHelper('lineItemIndex', function (index, options) {
    return Number(index + 1);
  });

  // Task: Highlight any matching strings
  Handlebars.registerHelper('highlight', function (string, query, options) {
    var text = string;
    var stringLower = string.toLowerCase();
    var querySafe = query.replace(/\W/g, '');
    var queryLower = querySafe.toLowerCase();
    var search = new RegExp(querySafe, 'gi');

    if (stringLower.indexOf(queryLower) > -1) {
      text = string.replace(search, '<strong>' + querySafe + '</strong>');
    }

    return text;
  });

  // Task: Return plural of string depending on count
  Handlebars.registerHelper('pluralise', function (options) {
    var count = options.hash['count'],
        singular = options.hash['string'],
        plural = options.hash['strings'] || singular + 's';

    if (count === undefined || singular === undefined) {
      return console.warn('No count or string passed');
    }

    if (count == 1) {
      return singular;
    } else {
      return plural;
    }
  });

  // Task: Output image url at a specified size, similar to Shopify's liquid filter
  Handlebars.registerHelper('img_url', function (options) {
    var image = options.hash['image'],
        size = options.hash['size'],
        scale = options.hash['scale'] || 1;
    var url = image;

    if (typeof image != 'undefined') {
      if (typeof size != 'undefined') {
        if (size.indexOf('x') != -1) {
          var filter = size.indexOf('x'),
              chars = size.length,
              sizes = size.split('x'),
              image_size = '';

          for (var i = 0; i < sizes.length; i++) {
            if (filter == 0 && i == 0 || filter != 0 && i != 0) {
              image_size += 'x';
            }
            if (sizes[i] != 0) {
              image_size += sizes[i] * scale;
            }
            if (filter == chars && i == 0) {
              image_size += 'x';
            }
          }

          image_size = '_' + image_size + '.';
          url = image.replace(/.([^.]*)$/, image_size + '$1');
        }
      }

      return url;
    } else {
      return console.warn('Error: image not found');
    }
  });

  // Task: Split a string at the requested position
  Handlebars.registerHelper('split', function (content, split, position, options) {
    if (content !== null && content !== undefined) {
      if (content.indexOf(split) >= 0) {
        var _split = content.split(_split);
        return _split[position];
      } else {
        return content;
      }
    } else {
      return false;
    }
  });

  // Task: Format money using the cart formatMoney function
  Handlebars.registerHelper('money', function (amount, options) {
    return '<span class="money">' + themeCurrency.formatMoney(amount, window.theme.moneyFormat) + '</span>';
  });

  // Task: Perform a math function and return the result
  Handlebars.registerHelper('quizdiscount', function (amount) {
    var returnAmount = amount * 100 / 85;
    return '' + themeCurrency.formatMoney(returnAmount, window.theme.moneyFormat);
  });

  // BOOLEAN variety
  Handlebars.registerHelper({
    eq: (v1, v2) => v1 === v2,
    ne: (v1, v2) => v1 !== v2,
    lt: (v1, v2) => v1 < v2,
    gt: (v1, v2) => v1 > v2,
    lte: (v1, v2) => v1 <= v2,
    gte: (v1, v2) => v1 >= v2,
    and() {
      return Array.prototype.slice.call(arguments, 0, -1).every(Boolean);
    },
    or() {
      return Array.prototype.slice.call(arguments, 0, -1).some(Boolean);
    }
  });
};

exports.default = handlebarsHelpers;
